import React from 'react'
import DataTable from 'react-data-table-component';

function BuketsTable_Orion(props) {
  let { data } = props;

  const columns = [
    {
      name: 'Vin Number',
      selector: (row) => row.key.vehicleId,
      sortable: true,
      // width: '25%',
    },
    {
      name: 'Value',
      selector: (row) => row.median_Range.values["50.0"].toFixed(2),
      sortable: true,
      // width: '15%'
    },
    // {
    //   name: 'Reg No',
    //   selector: (row) => row.key.vehicle_registration_number,
    //   sortable: true,
    //   width: '20%',
    // },
    // {
    //   name: 'Depot',
    //   selector: (row) => row.key.Depot_Name,
    //   sortable: true,
    //   width: '20%',
    // },
    // {
    //   name: 'City',
    //   selector: (row) => row.key.DLR_ORG_CITY,
    //   sortable: true,
    //   width: '20%',
    // }
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#83A4CF',
        color: '#fff',
        fontWeight: 'bold'
      },
    },
  };

  return (
    <>
      {/* {(data.length == 0) ? "<tr><td colSpan={2}>No data found</td></tr>" : data.map((x, index) => {
        return (<tr key={x.key}>
          <td scope="row ">{x.key.vehicleId}</td>
          <td >{(x.median_Range.values["50.0"]).toFixed(2)} </td>
        </tr>)
      })} */}

      <DataTable
        columns={columns}
        data={data}
        customStyles={customStyles}
        fixedHeader={true}
        fixedHeaderScrollHeight='250px'
      />
    </>
  );
}

export default BuketsTable_Orion
